import { z } from 'zod';

export const organizationSchema = z.object({
    id: z.string(),
    name: z.string(),
    owner: z.string(),
    hasLogo: z.boolean().default(false),
    accounts: z.array(z.string()),
    admins: z.array(z.string()),
});

export type Organization = z.infer<typeof organizationSchema>;

export const organizationAnalyticsSchema = z.object({
    membersCount: z.number().optional(),
    adminsCount: z.number(),
    accountsCount: z.number(),
});

export const organizationCreateInputSchema = z.object({
    name: z.string().min(1, 'Name is required'),
});

export type OrganizationCreateInput = z.infer<typeof organizationCreateInputSchema>;

export interface OrganizationUpdateInput {
    name?: string;
}
